import { Directive, HostBinding, ElementRef } from "@angular/core";

@Directive({
    selector:
        `[igHasValue],` +
        `input[type="tel"],` +
        `input[type="text"],` +
        `input[type="email"],` +
        `input[type="number"],` +
        `select`,
})
export class HasValueDirective {
    @HostBinding("class.has--value")
    public get hasValueClassName() {
        return !!this.element.nativeElement.value;
    }

    constructor(private element: ElementRef) {}
}
